import DockingViewState from '../../../store/schema/DockingViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('updateDockingHeight')(function updateDockingHeight(
    dockingViewState: DockingViewState,
    topDockingHeight: number,
    bottomDockingHeight: number
) {
    dockingViewState.topDockingHeight = topDockingHeight;
    dockingViewState.bottomDockingHeight = bottomDockingHeight;
});
